export function isValidNumberValue(number) {
  const value = Number(number)
  return Number.isInteger(value) && value >= 0
}
